var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 74,
    viewBox: "0 0 143 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 27,
    width: 44,
    height: 47,
    rx: 7,
    fill: "#F9F1D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 27,
    width: 44,
    height: 46,
    rx: 7,
    fill: "#F9F1D6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 57,
    width: 30,
    height: 13,
    rx: 5,
    fill: "#F96652"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 0.5,
    width: 50,
    height: 65,
    rx: 6.5,
    fill: "#D3F2D6",
    stroke: "#81CF89"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 46,
    width: 35,
    height: 15,
    rx: 5,
    fill: "#F96652"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 57,
    width: 29,
    height: 13,
    rx: 5,
    fill: "#F96652"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestBg);
export default __webpack_public_path__ + "static/media/request_bg.90e7bcd002b641fd8d6faefd83842761.svg";
export { ForwardRef as ReactComponent };